import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Layout from '@/views/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      name: 'dashboard',
      meta: {
        title: 'dashboard',
        icon: 'dashboard'
      }
    }, {
      path: 'todolist',
      component: () => import('@/views/todolist/dashboard'),
      name: 'todolist',
      meta: {
        title: 'todolist'
      },
      hidden: true
    }]
  }
]

export const asyncRouterMap = [
  // 账户管理
  {
    path: '/customer-management',
    name: 'customer',
    component: Layout,
    redirect: '/customer-management/BillingInformation',
    meta: {
      title: 'customer',
      icon: 'people'
    },
    children: [{
        path: '/BillingInformation',
        component: () => import('@/views/customer-management/BillingInformation'),
        name: 'BillingInformation',
        meta: {
          title: 'BillingInformation',
          // icon: 'dashboard',
        }
      }, {
        path: '/companyAccountList',
        component: () => import('@/views/customer-management/companyAccountList'),
        name: 'companyAccountList',
        meta: {
          title: 'companyAccountList',
          // icon: 'dashboard',
        }
      },
      {
        path: '/supplier_account_information',
        component: () => import('@/views/customer-management/supplierAccountInformation'),
        name: 'supplierAccountInformation',
        meta: {
          title: 'supplierAccountInformation',
          // icon: 'dashboard'
        }
      },
    ]
  },
  // 合同管理
  {
    path: '/contract-management',
    name: 'contract',
    component: Layout,
    redirect: '/contractInfo-management/contractList',
    meta: {
      title: 'contract',
      icon: 'excel'
    },
    children: [{
        path: '/contractList',
        component: () => import('@/views/contract-management/contractList'),
        name: 'contractList',
        meta: {
          title: 'contractList',
          // icon: 'dashboard'
        }
      },
      {
        path: '/ownerInformation',
        component: () => import('@/views/contract-management/ownerInformation'),
        name: 'ownerInformation',
        meta: {
          title: 'ownerInformation',
          // icon: 'dashboard',
        }
      },
      {
        path: '/contractDetail',
        component: () => import('@/views/contract-management/contractDetail'),
        name: 'contractDetail',
        hidden: true,
        meta: {
          title: 'contractDetail',
          // icon: 'dashboard'
        }
      }, {
        path: '/contractRelated',
        component: () => import('@/views/contract-management/contractRelated'),
        name: 'contractRelated',
        hidden: true,
        meta: {
          title: 'contractRelated',
          // icon: 'dashboard'
        }
      }, {
        path: '/contractEdit',
        component: () => import('@/views/contract-management/contractEdit'),
        name: 'contractEdit',
        hidden: true,
        meta: {
          title: 'contractEdit',
          // icon: 'dashboard'
        }
      }, {
        path: '/contractAdd',
        component: () => import('@/views/contract-management/contractEdit'),
        name: 'contractAdd',
        hidden: true,
        meta: {
          title: 'contractAdd',
          // icon: 'dashboard'
        }
      }, {
        path: '/accountList',
        component: () => import('@/views/contract-management/accountList'),
        name: 'accountList',
        meta: {
          title: 'accountList',
          // icon: 'dashboard',
        }
      },
      {
        path: '/invoiceManagement',
        component: () => import('@/views/contract-management/invoiceManagement'),
        name: 'invoiceManagement',
        meta: {
          title: 'invoiceManagement',
          // icon: 'dashboard',
        }
      }, {
        path: '/CollectionInformation',
        component: () => import('@/views/contract-management/CollectionInformation'),
        name: 'CollectionInformation',
        meta: {
          title: 'CollectionInformation',
          // icon: 'dashboard',
        }
      }, {
        path: '/refundManagement',
        component: () => import('@/views/contract-management/refundManagement'),
        name: 'refundManagement',
        meta: {
          title: 'refundManagement',
          // icon: 'dashboard',
        }
      }, {
        path: '/accountDetail',
        component: () => import('@/views/contract-management/accountDetail'),
        name: 'accountDetail',
        hidden: true,
        meta: {
          title: 'accountDetail',
          // icon: 'dashboard',
        }
      },
      {
        path: '/DownLoadApply',
        component: () => import('@/views/contract-management/DownLoadApply'),
        name: 'DownLoadApply',
        hidden: true,
        meta: {
          title: 'DownLoadApply',
          // icon: 'dashboard',
        }
      },
    ]
  },
   //  供应商管理
   {
    path: '/supplier-management',
    name: 'supplierManagement',
    component: Layout,
    redirect: '/supplier-management/contractList',
    meta: {
      title: 'supplierManagement',
      icon: 'send'
    },
    children: [
      {
        path: '/supplier_contractList',
        component: () => import('@/views/supplier-management/contractList/contractList'),
        name: 'supplierContractList',
        meta: {
          title: 'supplierContractList',
          // icon: 'dashboard'
        }
      },
      {
        path: '/supplier_contractDetail',
        component: () => import('@/views/supplier-management/contractDetail'),
        name: 'supplierContractDetail',
        hidden: true,
        meta: {
          title: 'supplierContractDetail',
          // icon: 'dashboard'
        }
      },
      {
        path: '/supplier_contractEdit',
        component: () => import('@/views/supplier-management/contractEdit'),
        name: 'supplierContractEdit',
        hidden: true,
        meta: {
          title: 'supplierContractEdit',
          // icon: 'dashboard'
        }
      },
      {
        path: '/supplier_contractAdd',
        component: () => import('@/views/supplier-management/contractEdit'),
        name: 'supplierContractAdd',
        hidden: true,
        meta: {
          title: 'supplierContractAdd',
          // icon: 'dashboard'
        }
      },
      {
        path: '/billReceiptManagement',
        component: () => import('@/views/supplier-management/billReceiptManagement'),
        name: 'billReceiptManagement',
        meta: {
          title: 'billReceiptManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/payment_management',
        component: () => import('@/views/supplier-management/paymentManagement'),
        name: 'paymentManagement',
        meta: {
          title: 'paymentManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/returnManagement',
        component: () => import('@/views/supplier-management/returnManagement'),
        name: 'returnManagement',
        meta: {
          title: 'returnManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/supplierDownLoadApply',
        component: () => import('@/views/supplier-management/DownLoadApply'),
        name: 'supplierDownLoadApply',
        hidden: true,
        meta: {
          title: 'supplierDownLoadApply',
          // icon: 'dashboard',
        }
      },
    ]
  },
  // 活动管理
  {
    path: '/activity-management',
    name: 'activity',
    component: Layout,
    redirect: '/activity-management/activityList',
    meta: {
      title: 'activity',
      icon: 'member-manage'
    },
    children: [{
        path: '/activityList',
        component: () => import('@/views/activity-management/activityList'),
        name: 'activityList',
        meta: {
          title: 'activityList',
          // icon: 'dashboard'
        }
      },
      {
        path: '/stockDetail',
        component: () => import('@/views/activity-management/stockDetail'),
        name: 'stockDetail',
        hidden: true,
        meta: {
          title: 'stockDetail',
          // icon: 'dashboard'
        }
      },
      {
        path: '/stockData',
        component: () => import('@/views/activity-management/stockData'),
        name: 'stockData',
        meta: {
          title: 'stockData',
          // icon: 'dashboard'
        }
      },
      {
        path: '/costTransfer',
        component: () => import('@/views/activity-management/costTransfer'),
        name: 'costTransfer',
        meta: {
          title: 'costTransfer',
          // icon: 'dashboard'
        }
      }
    ]
  },
  // 批次管理
  {
    path: '/batch-management',
    name: 'batch',
    component: Layout,
    redirect: '/batch-management/batchInfo',
    meta: {
      title: 'batch',
      icon: 'order-manage'
    },
    children: [{
        path: '/batchInfo',
        component: () => import('@/views/batch-management/batchInfo'),
        name: 'batchInfo',
        meta: {
          title: 'batchInfo',
          // icon: 'dashboard'
        }
      },
      {
        path: '/batchDetailsDownload',
        component: () => import('@/views/batch-management/batchDetailsDownload'),
        name: 'batchDetailsDownload',
        meta: {
          title: 'batchDetailsDownload',
          // icon: 'dashboard'
        }
      },
      
      {
        path: '/emailConfig',
        component: () => import('@/views/batch-management/emailConfig'),
        name: 'emailConfig',
        meta: {
          title: 'emailConfig',
          // icon: 'dashboard'
        }
      },
      {
        path: '/merchant365TagStatistics',
        component: () => import('@/views/batch-management/merchant365TagStatistics'),
        name: 'merchant365TagStatistics',
        meta: {
          title: 'merchant365TagStatistics',
        }
      },
      {
        path: '/stockCheck',
        component: () => import('@/views/batch-management/stockCheck'),
        name: 'stockCheck',
        meta: {
          title: 'stockCheck',
          // icon: 'dashboard'
        }
      },
      {
        path: '/PingAnBatch',
        component: () => import('@/views/batch-management/PingAnBatch'),
        name: 'PingAnBatch',
        meta: {
          title: 'PingAnBatch',
          // icon: 'dashboard'
        }
      },
      
      // ===========================================
      // {
      //   path: '/citicBatch',
      //   component: () => import('@/views/batch-management/citicBatch'),
      //   name: 'citicBatch',
      //   meta: {
      //     title: 'citicBatch',
      //     // icon: 'dashboard'
      //   }
      // },
      // {
      //   path: '/citicBatchAlipay',
      //   component: () => import('@/views/batch-management/citicBatchAlipay'),
      //   name: 'citicBatchAlipay',
      //   meta: {
      //     title: 'citicBatchAlipay',
      //     // icon: 'dashboard'
      //   }
      // },
      {
        path: '/citicThird',
        component: () => import('@/views/batch-management/citicThird'),
        name: 'citicThird',
        meta: {
          title: 'citicThird',
          // icon: 'dashboard'
        }
      },
      {
        path: '/dolphinDetails',
        component: () => import('@/views/batch-management/dolphinDetails'),
        name: 'dolphinDetails',
        meta: {
          title: 'dolphinDetails',
          // icon: 'dashboard'
        }
      },
      {
        path: '/wxStock',
        component: () => import('@/views/batch-management/wxStock'),
        name: 'wxStock',
        meta: {
          title: 'wxStock',
          // icon: 'dashboard'
        }
      },
      {
        path: '/cloudxStockManagement',
        component: () => import('@/views/batch-management/cloudxStockManagement'),
        name: 'cloudxStockManagement',
        meta: {
          title: 'cloudxStockManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/cloudxBatchQuery',
        component: () => import('@/views/batch-management/cloudxBatchQuery'),
        name: 'cloudxBatchQuery',
        meta: {
          title: 'cloudxBatchQuery',
          // icon: 'dashboard'
        }
      },
      {
        path: '/cloudxBatchDetail',
        component: () => import('@/views/batch-management/cloudxBatchDetail'),
        name: 'cloudxBatchDetail',
        hidden: true,
        meta: {
          title: 'cloudxBatchDetail',
          noCache: true
        }
      },
      {
        path: '/taobaoDetails',
        component: () => import('@/views/batch-management/taobaoDetails'),
        name: 'taobaoDetails',
        meta: {
          title: 'taobaoDetails',
          // icon: 'dashboard'
        }
      },
      {
        path: '/jiaheAlipay',
        component: () => import('@/views/batch-management/jiaheAlipay'),
        name: 'jiaheAlipay',
        meta: {
          title: 'jiaheAlipay',
          // icon: 'dashboard'
        }
      },
      {
        path: '/cloudxDetails',
        component: () => import('@/views/batch-management/cloudxDetails'),
        name: 'cloudxDetails',
        meta: {
          title: 'cloudxDetails',
          // icon: 'dashboard'
        }
      },
      {
        path: '/meituanDetail',
        component: () => import('@/views/batch-management/meituanDetail'),
        name: 'meituanDetail',
        meta: {
          title: 'meituanDetail',
          // icon: 'dashboard'
        }
      },
      {
        path: '/pinganPayDetailsDownload',
        component: () => import('@/views/batch-management/pinganPayDetailsDownload'),
        name: 'pinganPayDetailsDownload',
        meta: {
          title: 'pinganPayDetailsDownload',
          // icon: 'dashboard'
        }
      },
      {
        path: '/thirdPartBenefits',
        component: () => import('@/views/batch-management/thirdPartBenefits'),
        name: 'thirdPartBenefits',
        meta: {
          title: 'thirdPartBenefits',
          // icon: 'dashboard'
        }
      },
      {
        path: '/douyinData',
        component: () => import('@/views/batch-management/douyinData'),
        name: 'douyinData',
        meta: {
          title: 'douyinData',
        }
      },
    ]
  },
  // 数据核查
  {
    path: '/data-verification',
    name: 'dataVerification',
    component: Layout,
    redirect: '/data-verification/MissingBatch',
    meta: {
      title: 'dataVerification',
      icon: 'eye-open'
    },
    children: [{
        path: '/MissingBatch',
        component: () => import('@/views/data-verification/MissingBatch'),
        name: 'MissingBatch',
        meta: {
          title: 'MissingBatch',
          // icon: 'dashboard'
        }
      },
      {
        path: '/ProjectSummary',
        component: () => import('@/views/data-verification/ProjectSummary'),
        name: 'ProjectSummary',
        meta: {
          title: 'ProjectSummary',
          // icon: 'dashboard'
        }
      },
      {
        path: '/BillAndCollectChecked',
        component: () => import('@/views/data-verification/BillAndCollectChecked'),
        name: 'BillAndCollectChecked',
        meta: {
          title: 'BillAndCollectChecked',
          // icon: 'dashboard'
        }
      },
      {
        path: '/OperationReconciliationLag',
        component: () => import('@/views/data-verification/OperationReconciliationLag'),
        name: 'OperationReconciliationLag',
        meta: {
          title: 'OperationReconciliationLag',
          // icon: 'dashboard'
        }
      },
      {
        path: '/BatchReleaseFounds',
        component: () => import('@/views/data-verification/BatchReleaseFounds'),
        name: 'BatchReleaseFounds',
        meta: {
          title: 'BatchReleaseFounds',
          // icon: 'dashboard'
        }
      },
      {
        path: '/wxsnapshot',
        component: () => import('@/views/data-verification/wxsnapshot'),
        name: 'wxsnapshot',
        meta: {
          title: 'wxsnapshot',
          // icon: 'dashboard'
        }
      },
      {
        path: '/voucherComparison',
        component: () => import('@/views/data-verification/voucherComparison'),
        name: 'voucherComparison',
        meta: {
          title: 'voucherComparison',
          // icon: 'dashboard'
        }
      },
    ]
  },
  // 中信精彩365
  {
    path: '/zx-365',
    name: 'zx-365',
    component: Layout,
    redirect: '/zx-365/citic-citicBatchAlipay',
    meta: {
      title: 'zx365',
      icon: 'page-manage'
    },
    children: [
      // 2024.03.26新增  2024.09.23第二次新增(wx 4/5/6/7/8)
      // 【中信-支付宝-商编-业务属性-分中心】（已有）citicBatchAlipayNew
      // 【中信-微信-批次-业务属性】（新增）wx4
      // 【中信-微信-商编-业务属性】（已有）wx1
      // 【中信-微信-批次-分中心】（已有）wx2
      // 【中信-微信-批次-商编-分中心】（已有） wx3
      // 【中信-微信-批次-协同】（新增）wx5
      // 【中信-微信-商编-协同】（新增）wx6
      // 【中信-微信-批次-档位】（新增）wx7
      // 【中信-微信-商编-品牌】（新增）wx8
      {
        // 中信-支付宝-商编-业务属性-分中心
        path: '/citic-citicBatchAlipay',
        component: () => import('@/views/zx-365/citic/citicBatchAlipay.vue'),
        name: 'citicBatchAlipayNew',
        meta: {
          title: 'citicBatchAlipayNew',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-批次-业务属性
        path: '/citic/citicBatchWX4',
        component: () => import('@/views/zx-365/citic/citicBatchWX4'),
        name: 'citicBatchWX4',
        meta: {
          title: 'citicBatchWX4',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-商编-业务属性
        path: '/citic/citicBatchWX1',
        component: () => import('@/views/zx-365/citic/citicBatchWX1'),
        name: 'citicBatchWX1',
        meta: {
          title: 'citicBatchWX1',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-批次-分中心
        path: '/citic/citicBatchWX2',
        component: () => import('@/views/zx-365/citic/citicBatchWX2'),
        name: 'citicBatchWX2',
        meta: {
          title: 'citicBatchWX2',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-批次-商编-分中心
        path: '/citic/citicBatchWX3',
        component: () => import('@/views/zx-365/citic/citicBatchWX3'),
        name: 'citicBatchWX3',
        meta: {
          title: 'citicBatchWX3',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-批次-商编-分中心-业务归属
        path: '/citic/citicBatchWX3_plus',
        component: () => import('@/views/zx-365/citic/citicBatchWX3_plus'),
        name: 'citicBatchWX3_plus',
        meta: {
          title: 'citicBatchWX3_plus',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-批次-协同
        path: '/citic/citicBatchWX5',
        component: () => import('@/views/zx-365/citic/citicBatchWX5'),
        name: 'citicBatchWX5',
        meta: {
          title: 'citicBatchWX5',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-商编-协同
        path: '/citic/citicBatchWX6',
        component: () => import('@/views/zx-365/citic/citicBatchWX6'),
        name: 'citicBatchWX6',
        meta: {
          title: 'citicBatchWX6',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-精彩365商户标签
        path: '/citic/365tag',
        component: () => import('@/views/zx-365/citic/365tag'),
        name: '365tag',
        meta: {
          title: '365tag',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-批次-档位
        path: '/citic/citicBatchWX7',
        component: () => import('@/views/zx-365/citic/citicBatchWX7'),
        name: 'citicBatchWX7',
        meta: {
          title: 'citicBatchWX7',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-扩展字段3-批次-内容
        path: '/citic/citicBatchWXExt3',
        component: () => import('@/views/zx-365/citic/citicBatchWXExt3'),
        name: 'citicBatchWXExt3',
        meta: {
          title: 'citicBatchWXExt3',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-第三方批次-每日配置金额
        path: '/citic/citicStockAmount',
        component: () => import('@/views/zx-365/citic/citicStockAmount'),
        name: 'citicStockAmount',
        meta: {
          title: 'citicStockAmount',
          // icon: 'dashboard'
        }
      },
      {
        // 中信-微信-商编-品牌
        path: '/citic/citicBatchWX8',
        component: () => import('@/views/zx-365/citic/citicBatchWX8'),
        name: 'citicBatchWX8',
        meta: {
          title: 'citicBatchWX8',
          // icon: 'dashboard'
        }
      },
      {
        // 邮件所需数据
        path: '/citic/email',
        component: () => import('@/views/zx-365/citic/email'),
        name: 'email',
        meta: {
          title: 'email',
          // icon: 'dashboard'
        }
      },
      {
        // 邮件所需数据
        path: '/citic/email/detail',
        component: () => import('@/views/zx-365/citic/emailDetail'),
        name: 'emailDetail',
        hidden:true,
        meta: {
          title: 'emailDetail',
          // icon: 'dashboard'
        }
      },
      {
        // 月度数据分析---每日邮件
        path: '/citic/dataAnalysisEmail',
        component: () => import('@/views/zx-365/citic/dataAnalysisEmail'),
        name: 'dataAnalysisEmail',
        meta: {
          title: 'dataAnalysisEmail',
          // icon: 'dashboard'
        }
      },
      {
        // 中信商户号校验
        path: '/citic/zxMerchantCheck',
        component: () => import('@/views/zx-365/citic/zxMerchantCheck'),
        name: 'zxMerchantCheck',
        meta: {
          title: 'zxMerchantCheck',
          // icon: 'dashboard'
        }
      },
      {
        // 挂网活动信息映射
        path: '/citic/onlinePublishActivityMapping',
        component: () => import('@/views/zx-365/citic/onlinePublishActivityMapping'),
        name: 'onlinePublishActivityMapping',
        meta: {
          title: 'onlinePublishActivityMapping',
          // icon: 'dashboard'
        }
      },
    ]
  },
  // 平安商编管理
  {
    path: '/pingan-merchant',
    name: 'pinganMerchant',
    component: Layout,
    redirect: '/pingan-merchant/merchantTask',
    meta: {
      title: 'pinganMerchant',
      icon: 'shop-manage'
    },
    children: [
      {
        path: '/merchantTask',
        component: () => import('@/views/pingan-merchant/merchantTask'),
        name: 'merchantTask',
        // hidden: true,
        meta: {
          title: 'merchantTask',
        }
      },
      
      {
        path: '/merchantList',
        component: () => import('@/views/pingan-merchant/merchantList'),
        name: 'merchantList',
        meta: {
          title: 'merchantList',
          // icon: 'dashboard'
        }
      }
    ]
  },
  // 商户号管理
  {
    path: '/merchant-management',
    name: 'merchant',
    component: Layout,
    redirect: '/merchant-management/batchMerchant',
    meta: {
      title: 'merchant',
      icon: 'adjust'
    },
    children: [
      
      {
        path: '/merchantCheck',
        component: () => import('@/views/merchant-management/merchantCheck'),
        name: 'merchantCheck',
        // hidden: true,
        meta: {
          title: 'merchantCheck',
        }
      },
      {
        path: '/merchantCheckDetail',
        component: () => import('@/views/merchant-management/merchantCheckDetail'),
        name: 'merchantCheckDetail',
        hidden: true,
        meta: {
          title: 'merchantCheckDetail',
        }
      },
      {
        path: '/batchMerchant',
        component: () => import('@/views/merchant-management/batchMerchant'),
        name: 'batchMerchant',
        meta: {
          title: 'batchMerchant',
          // icon: 'dashboard'
        }
      },
      {
        path: '/batchMerchantDetail',
        component: () => import('@/views/merchant-management/batchMerchantDetail'),
        name: 'batchMerchantDetail',
        hidden: true,
        meta: {
          title: 'batchMerchantDetail',
        }
      },
      {
        path: '/merchantAutoTask',
        component: () => import('@/views/merchant-management/merchantAutoTask'),
        name: 'merchantAutoTask',
        // hidden: true,
        meta: {
          title: 'merchantAutoTask',
        }
      },
      {
        path: '/merchantAutoTaskDetail',
        component: () => import('@/views/merchant-management/merchantAutoTaskDetail'),
        name: 'merchantAutoTaskDetail',
        hidden: true,
        meta: {
          title: 'merchantAutoTaskDetail',
        }
      },
    ]
  },
   // 银行号码包管理
   {
    path: '/bank-package',
    name: 'package',
    component: Layout,
    redirect: '/bank-package/bankPackage',
    meta: {
      title: 'package',
      icon: 'table'
    },
    children: [
      {
        path: '/bankPackage',
        component: () => import('@/views/bank-package/packageList'),
        name: 'bankPackage',
        // hidden: true,
        meta: {
          title: 'bankPackage',
        }
      },
      {
        path: '/bankPackageDetail',
        component: () => import('@/views/bank-package/packageDetail'),
        name: 'packageDetail',
        hidden: true,
        meta: {
          title: 'packageDetail',
        }
      },
      {
        path: '/bankPackageBatch',
        component: () => import('@/views/bank-package/packageBatch'),
        name: 'packageBatch',
        // hidden: true,
        meta: {
          title: 'packageBatch',
        }
      },
      {
        path: '/packageAlipay',
        component: () => import('@/views/bank-package/packageAlipay'),
        name: 'packageAlipay',
        // hidden: true,
        meta: {
          title: 'packageAlipay',
        }
      },
    ]
  },
  // 商务管理
  {
    path: '/business-management',
    name: 'business',
    component: Layout,
    redirect: '/business-management/depositManagemant',
    meta: {
      title: 'business',
      icon: 'people'
    },
    children: [
      {
        path: '/depositManagemant',
        component: () => import('@/views/business-management/depositManagemant'),
        name: 'depositManagemant',
        meta: {
          title: 'depositManagemant',
        }
      }, 
      {
        path: '/procurementBids',
        component: () => import('@/views/business-management/procurementBids'),
        name: 'procurementBids',
        meta: {
          title: 'procurementBids',
        }
      }, 
      {
        path: '/otherBill',
        component: () => import('@/views/business-management/otherBill'),
        name: 'otherBill',
        meta: {
          title: 'otherBill',
        }
      }, 
      {
        path: '/AiCheckManagement',
        component: () => import('@/views/business-management/AiCheckManagement'),
        name: 'AiCheckManagement',
        meta: {
          title: 'AiCheckManagement',
        }
      }, 
      {
        path: '/bidReview',
        component: () => import('@/views/business-management/bidReview'),
        name: 'bidReview',
        meta: {
          title: 'bidReview',
        }
      }, 
    ]
  },
  // 用印管理
  {
    path: '/seal-management',
    name: 'seal',
    component: Layout,
    redirect: '/seal-management/sealManagemant',
    meta: {
      title: 'seal',
      icon: 'pen-leather'
    },
    children: [
      {
        path: '/sealManagemant',
        component: () => import('@/views/seal-management/sealManagemant'),
        name: 'sealManagemant',
        meta: {
          title: 'sealManagemant',
        }
      }, 
    ]
  },
  // 工具管理
  {
    path: '/tool-management',
    name: 'tool',
    component: Layout,
    redirect: '/tool-management/sftpManagement',
    meta: {
      title: 'toolManagement',
      icon: 'tool'
    },
    children: [{
        path: '/sftpManagement',
        component: () => import('@/views/tool-management/sftpManagement'),
        name: 'sftpManagement',
        meta: {
          title: 'sftpManagement',
          // icon: 'dashboard',
        }}
    ]
  },
  // 基础设置
  {
    path: '/basic-setting',
    name: 'basic',
    component: Layout,
    redirect: '/basic-setting',
    meta: {
      title: 'basic',
      icon: 'setting-manage'
    },
    children: [{
        path: '/menberManagement',
        component: () => import('@/views/basic-setting/menberManagement'),
        name: 'menberManagement',
        meta: {
          title: 'menberManagement',
          // icon: 'dashboard'
        }
      }, {
        path: '/roleManagement',
        component: () => import('@/views/basic-setting/roleManagement'),
        name: 'roleManagement',
        meta: {
          title: 'roleManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/menuManagement',
        component: () => import('@/views/basic-setting/menuManagement'),
        name: 'menuManagement',
        meta: {
          title: 'menuManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/logManagement',
        component: () => import('@/views/basic-setting/logManagement'),
        name: 'logManagement',
        meta: {
          title: 'logManagement',
          // icon: 'dashboard'
        }
      },
      {
        path: '/configNotice',
        component: () => import('@/views/basic-setting/configNotice'),
        name: 'configNotice',
        meta: {
          title: 'configNotice',
        }
      },
    ]
  },
  // 行政管理
  {
    path: '/administrative-management',
    name: 'administrative',
    component: Layout,
    redirect: '/administrative-management/documentCenter',
    meta: {
      title: 'administrative',
      icon: 'page-manage'
    },
    children: [
      {
        path: '/documentCenter',
        component: () => import('@/views/administrative-management/documentCenter'),
        name: 'documentCenter',
        meta: {
          title: 'documentCenter',
        }
      },
    ]
  },
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js